import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../Components/baseUrl";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.css";
import Menu from "../../Components/Menu";

const NewOrders = () => {
    const navigate = useNavigate();
    let token;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
    }
    useEffect(() => {
        document.title = "پایا | سفارشات جدید";
        token == null && navigate("/login", { replace: true });
    }, []);
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    useEffect(() => {
        let status = {
            status: [1],
        };
        let config = {
            url: `${baseUrl}/orders/get-orders-by-status`,
            method: "POST",
            data: status,
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setList(res.data.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);
    const [searchText, setSearchText] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const searchOrder = (e) => {
        const results = list.filter((item) =>
            item.company.store_name.includes(searchText)
        );
        setSearchResults(results);
    };

    return (
        <div className="container">
            <div className="search-box" id="search_box">
                <div className="pos-rel-search">
                    <input
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        type="text"
                        placeholder="جستجو کنید"
                    />
                    <svg
                        onClick={() => searchOrder()}
                        className="search-svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M18.5831 13.5489C19.204 11.7018 19.1293 9.69155 18.3731 7.89557C17.6169 6.09959 16.2312 4.64137 14.4761 3.79465C12.7209 2.94793 10.7171 2.77094 8.84074 3.29691C6.96438 3.82287 5.3445 5.01562 4.28521 6.65125C3.22592 8.28688 2.80005 10.2529 3.08754 12.1803C3.37504 14.1076 4.35614 15.8638 5.84666 17.1191C7.33718 18.3744 9.23463 19.0424 11.1828 18.9979C13.131 18.9534 14.9959 18.1993 16.4275 16.8772"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M16.5 16.958L21.5 21.958"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>
            {loading ? (
                <div className="emp-main">
                    <img src="/assets/images/loading.gif" width={50} />
                </div>
            ) : list && list.length !== 0 ? (
                <div className="orders-main">
                    <h1>سفارشات جدید</h1>
                    {searchResults && searchResults.length !== 0
                        ? searchResults.map((item) => {
                              if (item.Status == "سفارش جدید") {
                                  return (
                                      <a
                                          className="orders-card"
                                          onClick={(e) => {
                                              navigate(
                                                  "/panel/factor/" + item.id
                                              );
                                          }}
                                      >
                                          <img
                                              src={
                                                  item.company.avatar
                                                      ? item.company.avatar
                                                      : "/assets/images/logo.svg"
                                              }
                                              alt=""
                                          />
                                          <div>
                                              <span className="name">
                                                  {item.company.store_name}
                                              </span>
                                              <span className="fullname">
                                                  {item.company.name}{" "}
                                              </span>
                                              <span className="numb">
                                                  {item.code}
                                              </span>
                                              <div className="dates">
                                                  <button>{item.Status}</button>
                                                  <span>{item.Created_at}</span>
                                              </div>
                                          </div>
                                      </a>
                                  );
                              }
                          })
                        : list &&
                          list.length !== 0 &&
                          list.map((item) => {
                              if (item.Status == "سفارش جدید") {
                                  return (
                                      <a
                                          className="orders-card"
                                          onClick={(e) => {
                                              navigate(
                                                  "/panel/factor/" + item.id
                                              );
                                          }}
                                      >
                                          <img
                                              src={
                                                  item.company.avatar
                                                      ? item.company.avatar
                                                      : "/assets/images/logo.svg"
                                              }
                                              alt=""
                                          />
                                          <div>
                                              <span className="name">
                                                  {item.company.store_name}
                                              </span>
                                              <span className="fullname">
                                                  {item.company.name}{" "}
                                              </span>
                                              <span className="numb">
                                                  {item.code}
                                              </span>
                                              <div className="dates">
                                                  <button>{item.Status}</button>
                                                  <span>{item.Created_at}</span>
                                              </div>
                                          </div>
                                      </a>
                                  );
                              }
                          })}
                </div>
            ) : (
                <div className="emp-main">
                    <svg
                        width="145"
                        height="145"
                        viewBox="0 0 145 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M98.1771 135.938C104.016 135.938 108.75 131.204 108.75 125.365C108.75 119.525 104.016 114.792 98.1771 114.792C92.3378 114.792 87.6042 119.525 87.6042 125.365C87.6042 131.204 92.3378 135.938 98.1771 135.938Z"
                            fill="#F5C83D"
                        />
                        <path
                            d="M49.8438 135.938C55.683 135.938 60.4167 131.204 60.4167 125.365C60.4167 119.525 55.683 114.792 49.8438 114.792C44.0045 114.792 39.2708 119.525 39.2708 125.365C39.2708 131.204 44.0045 135.938 49.8438 135.938Z"
                            fill="#F5C83D"
                        />
                        <path
                            opacity="0.4"
                            d="M29.2417 23.8042L28.0333 38.6062C27.7917 41.4458 30.0271 43.8021 32.8667 43.8021H125.365C127.902 43.8021 130.017 41.8687 130.198 39.3312C130.983 28.6374 122.827 19.9375 112.133 19.9375H38.0021C37.3979 17.2792 36.1895 14.7416 34.3166 12.627C31.3562 9.42496 27.1271 7.55206 22.7771 7.55206H12.0833C9.60626 7.55206 7.55209 9.60623 7.55209 12.0833C7.55209 14.5604 9.60626 16.6146 12.0833 16.6146H22.5959C24.4688 16.6146 26.2209 17.4 27.4896 18.7292C28.7584 20.1188 29.3625 21.9312 29.2417 23.8042Z"
                            fill="#F5C83D"
                        />
                        <path
                            d="M123.915 52.8646H31.2354C28.6979 52.8646 26.6437 54.7979 26.402 57.275L24.227 83.5562C23.3812 93.8271 31.477 102.708 41.8083 102.708H108.992C118.054 102.708 126.029 95.2771 126.694 86.2146L128.688 58C128.929 55.2208 126.754 52.8646 123.915 52.8646Z"
                            fill="#F5C83D"
                        />
                    </svg>

                    <p className="emp-text">هیچ سفارش جدیدی ثبت نشده است</p>
                </div>
            )}
            <Menu active="cart" />
        </div>
    );
};

export default NewOrders;
